export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <span>25.43°S 49.27°W</span>
        <a
          className="footer-link"
          href="https://github.com/andregs/lean-dev-br"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
      </div>
    </footer>
  );
}
